import { Link } from "react-router-dom";
import Badge from "../../../components/Badge/Badge";
import { ProductWithoutIndex } from "../../../interfaces/interfaces";
import { Brand } from "../../../interfaces/types";
import { SalesStatus } from "../../../interfaces/enums";
import { subdomainTypes } from "../../../context/availableSubdomains";
import { Context, IContext } from "../../../context/ContextApp";
import { useContext } from "react";
import { springPromoCode } from "../../transactions/util";

interface Props {
  product: ProductWithoutIndex;
  displayBadge?: boolean;
}

const ProductCard = ({ product, displayBadge = false }: Props) => {
  const { brand, slug, code, name } = product;
  const { appBranch }: IContext = useContext(Context);

  if (product) {
    return (
      <Link to={`/products/${brand}/${slug}`} className="product-card-wrapper">
        <div className="product-card-overlay" />
        {renderImage(product)}
        <div className="product-code-and-brand">
          <b>{code}</b>
          <span>{formatBrand(brand)}</span>
        </div>
        <small>{name}</small>
        {appBranch && displayBadge && renderClearance(appBranch, product, displayBadge)}
        {appBranch === subdomainTypes.CA && springPromoCode.includes(code) && (
          <Badge style={{ width: "40%" }}>SPRING PROMO</Badge>
        )}
      </Link>
    );
  } else return <></>;
};

const renderImage = (product: ProductWithoutIndex) => {
  if (product.images.length === 0) {
    if (product.colors[0].images.length > 0) {
      return (
        <img
          style={{ width: "100%" }}
          src={product.colors[0].images[0].https_attachment_url_product}
          alt="product-color"
        />
      );
    } else {
      return (
        <img
          style={{ width: "100%" }}
          src="https://cdn.fashionbiz.com/Image+Not+Found.jpg"
          alt="not found"
        />
      );
    }
  } else {
    return (
      <img
        style={{ width: "100%" }}
        src={product.images[0].https_attachment_url_product}
        alt="product"
      />
    );
  }
};

// If we need custom banners for certain countries, we need to include "appBranch: subdomainTypes | ''" in the arguments for this function
const renderClearance = (
  appBranch: subdomainTypes,
  product: ProductWithoutIndex,
  displayBadge: boolean,
) => {
  const sales_statuses = [SalesStatus.Clearance, SalesStatus.Discontinued];

  if (
    product.slug.includes(SalesStatus.Clearance) ||
    sales_statuses.includes(product.sales_status)
  ) {
    return (
      <div className="double-badge">
        <Badge style={{ marginRight: "1em" }}>CLICK TO VIEW COLOURS</Badge>
        <Badge>NON-RETURNABLE</Badge>
      </div>
    );
  }

  if (product.badge_info) {
    return (
      <div className="double-badge">
        {product.sales_status !== SalesStatus.Normal && <Badge>{product.sales_status}</Badge>}
        <Badge>{product.badge_info}</Badge>
      </div>
    );
  }

  if (product.sales_status !== SalesStatus.Normal && displayBadge) {
    return (
      <div>
        <Badge>{product.sales_status}</Badge>
      </div>
    );
  }
};

const formatBrand = (brand: Brand) => {
  switch (brand) {
    case "biz-collection":
      return "Biz Collection";
    case "biz-corporates":
      return "Biz Corporates";
    case "syzmik":
      return "Syzmik";
    case "good-mates":
      return "GOODMATES";
    case "inaura":
      return "Inaura";

    case "direct-group":
      return "Direct Group";
    default:
      return "";
  }
};

export default ProductCard;
